export const MICROSITES_SUB_TABS = {
    CONFIGURATIONS: {
        name: 'configurations',
        caption: 'Configurations',
    },
};
